import { Fuelsform, Form } from "../../api";
import { fuelsCodes, fuelsKPIsCodes, fuelsFormulasIndicators, convertUnitsFinal } from "./fuelsForms";
import { computeRealKpiValue } from "./kpiRealValue";

const fuelsController = new Fuelsform();
const formController = new Form();

const CODE_TO_FIELD = Object.fromEntries(
  Object.entries(fuelsKPIsCodes).map(([field, code]) => [code, field])
);

const RAW_FIELDS = Object.keys(fuelsCodes);

/**
 * Lee el valor REAL de un KPI de Vehículos/Combustibles (sitio + año).
 * A diferencia de los otros módulos, acá ninguna fórmula usa línea base (VPS)
 * ni dotación de empleados como divisor — todo sale de los campos crudos de
 * combustible/vehículos ya cargados, así que no se piden esos dos datos.
 */
export async function getRealFuelsKpiValue({ accessToken, site, kpiCode, year }) {
  const fieldKey = CODE_TO_FIELD[kpiCode];
  if (!fieldKey) return { available: false, reason: "unknown_kpi" };

  return computeRealKpiValue({
    accessToken,
    site,
    year,
    fieldKey,
    rawFields: RAW_FIELDS,
    formulasFn: fuelsFormulasIndicators,
    convertFn: convertUnitsFinal,
    getRecordsFn: (t, s, ys) => fuelsController.getFuelsFormsByLastYears(t, s, ys),
    recordsWrapperKey: "fuelsForms",
    getUnitsFn: (t, s, y, f) => fuelsController.getLastUnitFieldsByYear(t, s, y, f),
    getBaselineFn: null,
    getWorkersFn: null,
    getConfigFn: (t, s, moduleName, active) => formController.getFormsBySite(t, s, moduleName, active),
    moduleName: "fuels",
    needsBaseline: false,
    needsEmployees: false,
  });
}
